import React, {Component} from 'react';
import Connect from './Connect';
import '../styles/App.css';
import {
  Container,
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography
} from '@mui/material';

class App extends Component {
  constructor() {
    super();
    this.state = {
      username: '',
      password: '',
      submitted: false,
      error: undefined
    };
    this.useChangeHandler = this.useChangeHandler.bind(this);
    this.passwordChangeHandler = this.passwordChangeHandler.bind(this);
    this.useSubmitHandler = this.useSubmitHandler.bind(this);
  }

  useChangeHandler(event) {
    this.setState({
      username: event.target.value,
    });
  }

  passwordChangeHandler(event) {
    this.setState({
      password: event.target.value
    });
  }

  componentDidMount() {
    let gc_token = window.localStorage.getItem('gc_token');
    if (/^".*"$/.test(gc_token)) gc_token = gc_token.replace(/^"(.*)"$/, '$1');

    if (gc_token && gc_token.length > 0) {
      localStorage.setItem('gc_token', gc_token);
      this.setState({ submitted: true });
    } else {
      this.setState({ submitted: false });
    }
  }

  useSubmitHandler(event) {  // action sur le formulaire
    event.preventDefault();
    const json = {username: this.state.username, password: this.state.password};
    fetch(`${process.env.REACT_APP_API_URL}/users/login`, {
      method: 'POST',
      body: JSON.stringify(json),
      headers: {"Content-Type": "application/json;charset=UTF-8"}
    }).then((response) => {
      response.json().then((body) => {
        if (body.err && body.err !== 'undefined') {
          this.setState({error: body.err});
        } else {
          localStorage.setItem('gc_token', 'JWT ' + body.token);
          this.setState({submitted: true});
        }
      });
    });
  };

  render() {
    if (this.state.submitted) {
      return (
        <Connect username={this.state.username} password={this.state.password} />
      );
    }

    return (
      <Container maxWidth="xs">
        <Box minHeight="100vh" display="flex" alignItems="center" justifyContent="center">
          <Card sx={{ width: '100%' }}>
            <CardContent>
              <Box display="flex" justifyContent="center" mb={2}>
                <img
                  src="https://graphcomment.com/images/logo.svg"
                  alt="graphcomment"
                  style={{ height: 48 }}
                />
              </Box>
              <Typography variant="h5" align="center" gutterBottom>
                Connexion
              </Typography>
              <Box component="form" onSubmit={this.useSubmitHandler} noValidate>
                <TextField
                  fullWidth
                  margin="normal"
                  label="Nom d'utilisateur"
                  name="username"
                  type="text"
                  value={this.state.username}
                  onChange={this.useChangeHandler}
                />
                <TextField
                  fullWidth
                  margin="normal"
                  label="Mot de passe"
                  name="password"
                  type="password"
                  value={this.state.password}
                  onChange={this.passwordChangeHandler}
                />
                {this.state.error && (
                  <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                    {this.state.error}
                  </Typography>
                )}
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  type="submit"
                  sx={{ mt: 2 }}
                >
                  Se connecter
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Container>
    );
  }
}

export default App;





